angular
	.module 'App.Repository'
	.factory 'OrderRepository',
		[
			'BaseRepository',
			'EntityAttributeService',
			'BACKEND_TRANSACTION_STATE',
			'BACKEND_TRANSACTION_PAYMENT_TYPE',
			(BaseRepository, EntityAttributeService, BACKEND_TRANSACTION_STATE, BACKEND_TRANSACTION_PAYMENT_TYPE) ->
				class OrderRepository extends BaseRepository
					@resource = '/orders'
					@isRestricted = true

					calculateOrderSum: (orders) ->
						if orders.length > 0
							for order in orders
								orderSum = 0
								order.is_invoiced = false

								if order.transactions
									for transaction in order.transactions
										if transaction.state == BACKEND_TRANSACTION_STATE.CAPTURED && transaction.type == BACKEND_TRANSACTION_PAYMENT_TYPE.INVOICE
											order.is_invoiced = true
											order.invoice_status = EntityAttributeService.getAttributeValue(transaction.attributes, 'invoice_status')

											if !_.isEmpty transaction.invoice
												order.invoice_number = transaction.invoice.invoice_number
											else
												order.invoice_number = null

											break

								for order_line_item in order.order_line_items
									orderSum += parseInt order_line_item.total_line_amount

									if order_line_item.addon_line_items.length > 0
										for addon_line_item in order_line_item.addon_line_items
											orderSum += parseInt addon_line_item.total_line_amount

									if order_line_item.bundled_line_items.length > 0
										for bundled_line_item in order_line_item.bundled_line_items
											orderSum += parseInt bundled_line_item.total_line_amount

								order.total_order_sum = orderSum / 100
						return orders
				return new OrderRepository
		]
